var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Middleware } from '@spotify-internal/remote-config-core';
import { createEventSender } from '@spotify-internal/event-sender';
import { exposureMiddleware as granularExposure } from './exposure';
import { errorExposureMiddleware } from './error-exposure';
import { consentExposureMiddleware } from './consent-exposure';
export const composedExposureMiddleware = Middleware.compose(consentExposureMiddleware, granularExposure, errorExposureMiddleware);
export const exposureMiddleware = next => (_a) => {
    var { transport, eventSender = createDefaultEventSender(transport) } = _a, opt = __rest(_a, ["transport", "eventSender"]);
    return composedExposureMiddleware(next)(Object.assign({ eventSender }, opt));
};
function createDefaultEventSender(transport) {
    if (!transport)
        throw new Error(`Either "transport" or "eventSender" must be provided.`);
    return createEventSender({ transport });
}
//# sourceMappingURL=index.js.map